import { render, staticRenderFns } from "./aulas-empty.vue?vue&type=template&id=11165149&scoped=true"
import script from "./aulas-empty.vue?vue&type=script&lang=js"
export * from "./aulas-empty.vue?vue&type=script&lang=js"
import style0 from "./aulas-empty.vue?vue&type=style&index=0&id=11165149&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11165149",
  null
  
)

export default component.exports